const observacionesEditables = [
  "USUARIO REPORTA HORA DE RECOGIDA SOBRE LAS 00h 00min,",
  "OP CAMBIA HORA DE RECOGIDA SOBRE LAS 00h 00min,",
  "RECOGIDA CON ATRASO DE 00h 00min",
  "OPERADOR CONFIRMA SERVICIOS ASIGNADOS DEL DD/MM/2025",
  "OPERADOR MICHEL CONFIRMA SERVICIOS ASIGNADOS DEL DD/MM/2025",
  "RECOGIDA NO SE REALIZA; NOVEDAD:",
  "RECOGIDA CON NOVEDAD:"
];

export default observacionesEditables;